import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

import ServiceLogo from "../../../assets/new-design/Logo/service_logo.svg";
import UserIcon from "../../../assets/new-design/Icon/user_icon_blue.svg";
import LogoutIcon from "../../../assets/new-design/Icon/logout_icon.svg";
import { signOutWithMediaCookieRevoke } from "../../../lib/logout";

export type HeaderPcProps = {
  className?: string;
  style?: "logout";
};

export default function HeaderPc({
  className,
  style = "logout",
}: HeaderPcProps) {
  const [username, setUsername] = useState("ゲスト");

  useEffect(() => {
    let mounted = true;

    const loadUsername = async () => {
      try {
        const session = await fetchAuthSession();
        const cognitoUsername =
          session.tokens?.idToken?.payload?.["cognito:username"];

        if (mounted && typeof cognitoUsername === "string") {
          setUsername(cognitoUsername);
        }
      } catch {}
    };

    void loadUsername();

    return () => {
      mounted = false;
    };
  }, []);

  const onLogout = async () => {
    try {
      await signOutWithMediaCookieRevoke();
    } catch {}
  };

  return (
    <div
      className={
        className ||
        "bg-npc-button-primary content-stretch flex items-center justify-between px-sds-size-space-600 py-sds-size-space-300 relative w-[1440px]"
      }
      data-node-id="162887:35279"
    >
      <div
        className="content-stretch flex gap-sds-size-space-200 items-center relative shrink-0"
        data-node-id="162887:35280"
        data-name="Service Logo Container"
      >
        <div
          className="h-[44px] relative shrink-0 w-[300px]"
          data-node-id="162887:35281"
          data-name="service_logo"
        >
          <img
            alt=""
            className="absolute block inset-0 max-w-none size-full"
            src={ServiceLogo}
          />
        </div>
        <p
          className="[word-break:break-word] font-['Noto_Sans_JP:Regular'] font-normal leading-[1.4] relative shrink-0 text-[16px] text-npc-lightgray whitespace-nowrap"
          data-node-id="162887:35302"
        >
          NTT西日本
        </p>
      </div>
      <div
        className="content-stretch flex gap-sds-size-space-400 items-center justify-center relative shrink-0"
        data-node-id="162887:35303"
        data-name="Button Container"
      >
        <div
          className="content-stretch flex gap-[8px] items-center relative shrink-0"
          data-node-id="162945:20633"
          data-name="Icon Button Container"
        >
          <div
            className="relative shrink-0 size-[24px]"
            data-node-id="162946:18289"
            data-name="Ellipse 310 1"
          >
            <img
              alt=""
              className="absolute block inset-0 max-w-none size-full"
              src={UserIcon}
            />
          </div>
          <p
            className="[word-break:break-word] font-[family-name:'Inter:Regular'] font-[400] leading-[1.4] not-italic relative shrink-0 text-npc-white text-[14px] whitespace-nowrap"
            data-node-id="162887:35306"
          >
            {username}
          </p>
        </div>
        <button
          className="border border-npc-white border-solid content-stretch flex gap-sds-size-space-200 h-[36px] items-center justify-center px-sds-size-space-200 relative rounded-sds-radius-100 shrink-0 w-[120px]"
          data-node-id="162890:37940"
          data-name=".HeaderButton"
          onClick={onLogout}
          type="button"
        >
          <div
            className="relative shrink-0 size-[20px]"
            data-node-id="I162890:37940;162890:36909"
            data-name="Icon"
          >
            <img
              alt=""
              className="absolute block inset-0 max-w-none size-full"
              src={LogoutIcon}
            />
          </div>
          <p
            className="[word-break:break-word] font-['Noto_Sans_JP:Regular'] font-normal leading-[1.4] relative shrink-0 text-[14px] text-npc-white whitespace-nowrap"
            data-node-id="I162890:37940;162890:36910"
          >
            ログアウト
          </p>
        </button>
      </div>
    </div>
  );
}
